import { EMessageBulletType } from './multi/voyageMessageBulletCreate'
import { voyageColors } from './voyageColors-sidecar'

export interface IVoyageCrewWeaponState {
  data: IVoyageCrewWeaponData
  reloadTimer: number
}

export interface IVoyageCrewWeaponData {
  damage: number
  reloadTime: number
  maxDistance: number
  color: number
  speed: number
  type: EMessageBulletType
}

export function create(data: IVoyageCrewWeaponData): IVoyageCrewWeaponState {
  return {
    data,
    reloadTimer: 0,
  }
}

export function getAlienBlaster(): IVoyageCrewWeaponData {
  return {
    damage: 15,
    reloadTime: 3,
    maxDistance: 500,
    speed: 200,
    color: voyageColors.green,
    type: EMessageBulletType.Alien,
  }
}

export function getCrewBlaster(): IVoyageCrewWeaponData {
  return {
    damage: 25,
    reloadTime: 2,
    maxDistance: 300,
    speed: 300,
    color: voyageColors.red,
    type: EMessageBulletType.Crew,
  }
}
